import React from "react";

interface ChapterContextProps {
    onViewCourseware: (id?: number) => void;
}

export const ChapterContext = React.createContext<ChapterContextProps>({
    onViewCourseware: () => null
});
